module.exports = __webpack_public_path__ + "img/badge-check.58e12a53.png";